module.exports = __webpack_public_path__ + "img/15.255c60d6.png";